import { Component, h } from 'preact'
import ButtonControl from '../button-control'
import Content from '../common/Content'
import UserAvatar from '../User/UserAvatar'
import formatDateInLocalTimezone from '../utils/dateFormatting'
import { Reply } from './interfaces'
import Axios from 'axios'
import PostEditor from '../editor/postEditorViaAPI'

interface Props extends Reply {
  topicType: 'productUpdate' | 'idea',
  isAuthor?: boolean,
  replyNumber?: number,
  replyCount?: number,
  topicId: number
}

interface State extends Reply {
  topicType: 'productUpdate' | 'idea',
  showEditor?: boolean,
  isAuthor?: boolean,
  replyNumber?: number,
  replyCount?: number
}

class Post extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      ...props,
      showEditor: false
    }
    this.onTrash = this.onTrash.bind(this)
  }

  async onTrash () {
    const setTrashed = async (trashed: boolean) => {
      await Axios.post(`/community/api/${this.props.topicType}s/replies/${this.state.id}/toggleTrashed`, {
        trashed
      }).then(() => {
        this.setState({ trashed })
      })
    }

    await setTrashed(!this.state.trashed)
  }

  render ({ id, author, repliedAt, isAuthor = false, replyNumber, replyCount, topicType, topicId }: Props, { trashed, content, showEditor }: State) {
    return (
      <article className={`post panel panel-default  status--author ${trashed ? 'status--trashed' : ''}`}>
        <div className='post--inner-wrapper'>
          <div className='panel-body'>
            <div className='user-avatar--container clearfix'>
              <UserAvatar
                user={{ ...author, ...{ name: author.username }, ...{ url: `/member/profile/?userid=${author.id}` } }}
                extraClass='avatar avatar--L'
                style={{ float: 'left' }}
                showRank
                openInNewTab
              />
              <div className='user-avatar--info'>
                <h4>
                  <strong>
                    <a href={`/member/profile/?userid=${author.id}`}>{author.username}</a>
                  </strong>
                </h4>
                <span className='text-muted posts-count clearfix'>{author.reputation.repliesMade} replies</span>
              </div>
            </div>
            <div className='post--content-container'>
              <header className='clearfix'>
                <span className='text-muted post--time'>
              Posted on {formatDateInLocalTimezone(new Date(repliedAt).getTime() / 1000)}
                </span>
                <div className='pull-right pill-container'>
                  {trashed && <span className='pill pill--trashed'>trashed</span>}
                  {isAuthor && !trashed && <span className='pill pill--author'>author</span>}
                  <span className='pill pill--counter'>{replyNumber} of {replyCount}</span>
                </div>
              </header>
              <div className='post--content post--content-new-editor'>
                {
                  showEditor ? (
                    <PostEditor
                      replyId={id}
                      topicId={topicId}
                      isControl
                      data={content}
                      onSuccess={(content: string) => this.setState({ showEditor: false, content })}
                      onCancel={() => { this.setState({ showEditor: false }) }}
                      type={`${topicType}s` as 'productUpdates' | 'ideas'}
                      redirect={false}
                      isGuest={false}
                      disableFileAttachments={false}
                    />
                  ) : (
                    <Content
                      content={content || ''}
                      className='qa-post-content'
                      isControl
                    />
                  )
                }
              </div>
            </div>
          </div>
          <div className='post__panel-footer clearfix'>
            <div />
            <div className='post__panel-footer--action-box js-post-panel-footer-action-box'>
              <ButtonControl
                title='Edit post'
                variant='secondary'
                disabled={trashed}
                onClick={() => { this.setState({ showEditor: true }) }}
              />
              <ButtonControl
                title={trashed ? 'Restore' : 'Trash'}
                variant={trashed ? 'secondary' : 'warning'}
                onClick={this.onTrash}
              />
            </div>
          </div>
        </div>
      </article>
    )
  }
}

export default Post
